import { IAddEmployerData } from '../models/subscription.model';

export const STEP_THREE = {
  flowName: 'Suscribir APV',
  back: 'Volver al paso anterior',
  title: 'Paso 3: Empleador',
  subtitle: 'Tu empleador descontará tu APV por planilla cada mes',
  cardTitle: 'Busca tu empleador',
  cardSubtitle: 'Ingresa su RUT. Lo puedes encontrar en tu liquidación de sueldo',
  rutLabel: 'RUT de empleador',
  rutPlaceholder: '12.345.678-9',
  searchButton: 'Buscar',
  searchingButton: 'Buscando...',
  rutError:
    'No encontramos un empleador asociado a ese RUT. Por favor, valida que sea correcto.',
  emailLabel: 'Puedes guardar el correo de tu empleador',
  emailPlaceholder: 'correo@frasal.cl',
  emailButton: 'Guardar',
  emailUpdateButton: 'Actualizar',
  emailError: 'Ingresa un correo válido. Ejemplo: contacto@correo.com',
  submitButton: 'Continuar',
  editTitle: 'Edita tu empleador',
  editBack: 'Volver a confirmar la suscripción',
  editSubmit: 'Guardar cambios',
};

export const EMPLOYER_FIELDS: {
  label: string;
  key: keyof IAddEmployerData;
}[] = [
  { label: 'Razón social', key: 'employerName' },
  { label: 'Giro:', key: 'employerActivity' },
  { label: 'Dirección:', key: 'employerAddress' },
  { label: 'Región:', key: 'employerRegion' },
  { label: 'Comuna:', key: 'employerCommune' },
  { label: 'Ciudad:', key: 'employerCity' },
  { label: 'Teléfono:', key: 'employerPhone' },
  { label: 'RUT:', key: 'employerFullRut' },
];
